import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './spinner.sass'

const Spinner = ({ className, text, isCentered }) => (
  <div className={classNames('spinner', className, { '--centered': isCentered })}>
    <svg
      className="spinner__outer"
      width="66px"
      height="66px"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle className="spinner__path" fill="none" strokeWidth="2" cx="33" cy="33" r="30" />
    </svg>
    <svg
      className="spinner__inner"
      width="66px"
      height="66px"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle className="spinner__path" fill="none" strokeWidth="4" cx="33" cy="33" r="26" />
    </svg>
    {text && <div className="spinner__text">{text}</div>}
  </div>
)

Spinner.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  isCentered: PropTypes.bool,
}

Spinner.defaultProps = {
  className: '',
  text: null,
  isCentered: false,
}

export default Spinner
